import React from "react";
import { useQuery } from "@tanstack/react-query";
import { backendApi } from "@/api/backendApi";
import { Users, Send, MousePointerClick, MessageSquare } from "lucide-react";

export default function YourAnalyticsWidget() {
    const { data: analytics } = useQuery({
        queryKey: ["dashboard", "analytics"],
        queryFn: () => backendApi.entities.Dashboard.analytics(),
        staleTime: 60000,
        enabled: !!backendApi.auth.getToken(),
    });
    const cards = [
        {
            id: "views",
            label: "Profile Views",
            count: analytics?.profileViews || 0,
            trend: "+12%",
            bg: "bg-blue-50",
            icon: <Users className="w-4 h-4 text-blue-500" />,
            textColor: "text-blue-600",
            trendColor: "text-green-500",
        },
        {
            id: "apps",
            label: "Applications",
            count: analytics?.applicationAnalytics?.total || 0,
            trend: "+3",
            bg: "bg-purple-50",
            icon: <Send className="w-4 h-4 text-purple-500" />,
            textColor: "text-purple-600",
            trendColor: "text-green-500",
        },
        {
            id: "searches",
            label: "Recruiter Searches",
            count: analytics?.recruiterSearches || 0,
            trend: "+24%",
            bg: "bg-green-50",
            icon: <MousePointerClick className="w-4 h-4 text-green-500" />,
            textColor: "text-green-600",
            trendColor: "text-green-500",
        },
        {
            id: "response",
            label: "Response Rate",
            count: analytics?.responseRate || "0%",
            trend: "-5%",
            bg: "bg-orange-50",
            icon: <MessageSquare className="w-4 h-4 text-orange-500" />,
            textColor: "text-orange-600",
            trendColor: "text-red-500",
        },
    ];

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 mb-6">
            <h3 className="text-gray-900 font-semibold mb-4">Your Analytics</h3>

            <div className="grid grid-cols-2 gap-4">
                {cards.map((card) => (
                    <div
                        key={card.id}
                        className={`rounded-xl p-4 flex flex-col justify-between border border-gray-100 ${card.bg}`}
                    >
                        <div className="flex justify-between items-start mb-2">
                            {card.icon}
                            <span className={`text-xs font-medium ${card.trendColor}`}>
                                {card.trend}
                            </span>
                        </div>

                        <div>
                            <span className={`text-2xl font-bold ${card.textColor} block mb-1`}>
                                {card.count}
                            </span>
                            <span className="text-xs text-gray-500 leading-tight block">
                                {card.label}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
